import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    TableRow,
    TableRowColumn
} from 'material-ui/Table';
import FuseTheme from '../global/theme';
import IconButton from 'material-ui/IconButton';
import ContentDelete from 'material-ui/svg-icons/action/delete';

/**
 * A component for creating a Price Level Price row with optional deletion.
 * Loaded by PriceLevelPriceTable.
 *
 */
class PriceLevelPriceTableRow extends Component {
    constructor(props) {
        super(props);
        this.handleDeleteClick = this.handleDeleteClick.bind(this);
    }

    handleDeleteClick() {
        this.props.onDeleteClick(this.props.price_level);
    }

    render() {
        const styles = {
            block: {display: 'block'},
            row: {height: '40px'},
            alignTop: {verticalAlign: 'top'},
            icon: {height: '40px', padding: '10px', overflow: 'inherit'},
            fieldSmall: {display: 'inline-block', maxWidth: 100, maxHeight: 62},
        };
        return (
            <TableRow style={styles.row}>
                <TableRowColumn className={'row-price-level-' + this.props.price_level} style={styles.row}>
                    <span>{this.props.price_level}</span>
                </TableRowColumn>

                <TableRowColumn className={'row-price-' + this.props.price_level} style={styles.row}>
                    <span>{this.props.price}</span>
                </TableRowColumn>

                <TableRowColumn style={styles.row}>
                    {this.props.showDelete &&
                    <IconButton
                        style={styles.icon}
                        onClick={(e) => this.handleDeleteClick(e)}
                    >
                        <ContentDelete color={FuseTheme.palette.primary1Color}/>
                    </IconButton>
                    }
                </TableRowColumn>
            </TableRow>
        )
    }
}

PriceLevelPriceTableRow.propTypes = {
    addField: PropTypes.bool,
    price_level: PropTypes.string.isRequired,
    price: PropTypes.string.isRequired,
    showDelete: PropTypes.bool,
    onDeleteClick: PropTypes.func,
};

PriceLevelPriceTableRow.defaultProps = {
    addField: true,
    price_level: '',
    price: 0,
    style: {padding: 0},
};

export default PriceLevelPriceTableRow;


// WEBPACK FOOTER //
// ./src/Fuse/components/PriceLevelPriceTableRow.js